import { inferSectionMode } from 'pages/private/owner/Workouts/forms/workoutBuilder/inferSectionMode';
import { WorkoutTemplateRetrieve } from 'types';
import { ScoreTypeEnum } from 'types/enums';

import type { WorkoutTemplatePreviewData } from '../../ModalWorkoutTemplatePreview';

export function buildPreviewData(template: WorkoutTemplateRetrieve): WorkoutTemplatePreviewData {
  return {
    workoutTemplateId: template.workoutTemplateId,
    name: template.name,
    athleteNotes: template.athleteNotes,
    coachNotes: template.coachNotes,
    sections: [...template.sections]
      .sort((a, b) => a.orderIndex - b.orderIndex)
      .map(section => ({
        name: section.name,
        workoutInstructions: section.workoutInstructions,
        scoreEntireSection: inferSectionMode(section) === 'section_level',
        movements: (section.movements || [])
          .slice()
          .sort((a, b) => a.orderIndex - b.orderIndex)
          .map(movement => ({
            workoutMovement: {
              workoutMovementId:
                movement.workoutMovement?.workoutMovementId ?? movement.workoutMovementId ?? undefined,
              name: movement.workoutMovement?.name || 'Unknown Movement',
              movementType: movement.workoutMovement?.movementType,
            },
            scoreType: movement.scoreType as ScoreTypeEnum,
          })),
      })),
  };
}
